<template>
    <div class="container" v-show="isShow">
        <a class="popup-close-button" @click="showPage">x</a>
        <!-- http://clips.vorwaerts-gmbh.de/big_buck_bunny.mp4 -->
        <div class="content">
            <video class="video" ref="videoContainer" 
               controls src="/video/highRoadLong.mp4"
               ></video>
               <!-- autoplay="true" -->
        </div>  
    </div>

</template>

<script>
import  $bus  from '../bus.ts'
export default {
    name:'VideoAbout',
    data(){
        return {
            title:'',
            isShow: false
        }
    },
    methods:{
        videoPause(){
            this.$refs.videoContainer.pause();
            this.isShow = false;
        },
        startVideoAbout(){
            this.isShow = true ;
            this.$refs.videoContainer.pause();
        },
        controlPlayVideo(value){
            // this.isShow = true ;
            if(value){
                this.$refs.videoContainer.play();
            }else{
                this.$refs.videoContainer.pause();
            }
        },
        showPage(){
            this.isShow = !this.isShow;
        }
    },
    mounted(){
        // $bus.on('startPlayVideo',this.videoPlay);
        $bus.on('stopPlayVideo',this.videoPause);
        $bus.on('startVideoAbout',this.startVideoAbout);
        $bus.on('controlPlayVideo',this.controlPlayVideo);
    },
    unmounted(){
        // $bus.off('startPlayVideo');
        $bus.off('stopPlayVideo');
        $bus.off('startVideoAbout');
        $bus.off('controlPlayVideo');
    }
}
</script>

<style scoped>
.container{
    position: absolute;
    top: 60%;
    left: 75%;
    width: 390px;
    height: 325px;
    padding: .8em;
    border-radius: 10px;
    background-color: rgba(0,0,0,0.6);
}
video{
    width: 100%;

}
.content{
    margin-top: 5%;
    width: 100%;
}
.popup-close-button {
    position: absolute;
    top: 0;
    right: 14px;
    padding: 5px 10px 0 0;
    text-align: center;
    width: 18px;
    height: 14px;
    font: 20px/16px Tahoma, Verdana, sans-serif;
    text-decoration: none;
    font-weight: 700;
    background: transparent;
    z-index: 9999;
    color: aliceblue;
  }

  .popup-close-button:hover {
    cursor: pointer;
    color: red;
  }
</style>